import { render, staticRenderFns } from "./DeliverOrdersOnBehalf.vue?vue&type=template&id=3c3588b4&scoped=true&"
import script from "./DeliverOrdersOnBehalf.vue?vue&type=script&lang=js&"
export * from "./DeliverOrdersOnBehalf.vue?vue&type=script&lang=js&"
import style0 from "./DeliverOrdersOnBehalf.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DeliverOrdersOnBehalf.vue?vue&type=style&index=1&id=3c3588b4&scoped=true&lang=scss&"
import style2 from "./DeliverOrdersOnBehalf.vue?vue&type=style&index=2&id=3c3588b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3588b4",
  null
  
)

export default component.exports